export default {"src":"https://fishbrain.com/_next/static/media/massachusetts.b2021966.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};